import { Injectable, inject } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SalesAgent } from "../models/sales-agent.model";

@Injectable({
  providedIn: 'root'
})
export class SalesService {
    private http = inject(HttpClient);

    private apiUrl = environment.apiUrl;

    getSalesAgents(): Observable<SalesAgent[]> {
        return this.http.get<SalesAgent[]>(`${this.apiUrl}/sales-agents`);
    }

    getSalesAgentById(id: string): Observable<SalesAgent> {
        return this.http.get<SalesAgent>(`${this.apiUrl}/sales-agents/${id}`);
    }

    getSalesAgentByUserId(id: string): Observable<SalesAgent> {
        return this.http.get<SalesAgent>(`${this.apiUrl}/sales-agents/${id}/user`);
    }

    getSalesDashboard(id: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/sales-agents/${id}/dashboard`);
    }

    getSalesAgentFormsByUserId(id: string) {
        return this.http.get<any>(`${this.apiUrl}/sales-agents/${id}/forms`);
    }

    getSalesAgentW9FormsByUserId(id: string) {
        return this.http.get<any>(`${this.apiUrl}/sales-agents/${id}/forms/w9`);
    }

    getSalesAgentReferredAgents(id: number) {
        return this.http.get<any>(`${this.apiUrl}/sales-agents/${id}/referrals`)
    }

    trackReferralClick(agentId: string) {
        const params = new HttpParams().set('agentId', agentId);
        this.http.post(`${this.apiUrl}/analytics/track-click`, {}, { params })
            .subscribe({
                error: (err) => console.error('Failed to track click', err)
            });
        // this.http.post(`${this.apiUrl}/analytics/track-click?agentId=${agentId}`, {})
        // .subscribe({
        //     error: (err) => console.error('Failed to track click', err)
        // });
    }
}